import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0664d299&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=0664d299&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0664d299",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\mzkj\\要炼\\yl-pc-business\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0664d299')) {
      api.createRecord('0664d299', component.options)
    } else {
      api.reload('0664d299', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=0664d299&scoped=true&", function () {
      api.rerender('0664d299', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/storeInfo/contact/index.vue"
export default component.exports